import {
  Component,
  ChangeDetectorRef,
  ViewEncapsulation,
  Input,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { Subject } from 'rxjs';
import { NbDialogRef } from '@nebular/theme';

import {
  FitnessBlock,
  FitnessItem,
  FitnessItemHelper,
  SetsBased,
  SettingDetailRow,
  WeightType,
} from 'app/@core/interfaces/common/CalorieFriend/fitnessItem';
import { CopyFitnessItem } from 'app/BuildOps';
import { ExerciseProgressData } from 'app/@core/interfaces/common/CalorieFriend/exercise-progress';
import { TreeMapModule } from '@swimlane/ngx-charts';
import {convertKgToPounds, convertPoundsToKg} from './../../../../@core/utils/preferredUnitImperialConvertor';
import { cloneDeep } from 'lodash';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';

export interface SelectionOption {
  selectName: string;
  selectIndex: number;
}

/**
 * Component for Serving Size Selection inside Meal Item Selection widget.
 */
@Component({
  selector: 'app-exercise-edit',
  templateUrl: './exercise-edit.component.html',
  styleUrls: ['./exercise-edit.component.scss'],
  encapsulation: ViewEncapsulation.None,
})

/** ServiingSizeSelection component*/
export class ExerciseEditComponent {
  InputItem: FitnessItem = null;
  @Input('FitnessItem') FitnessItem: FitnessItem = null;

  @Input('PatientID') PatientID: number = -1;
  @Input('PatientName') PatientName: string = '';
  @Input('IsPreferredUnitImperial') IsPreferredUnitImperial: boolean = false;

  @Output() added = new EventEmitter<FitnessItem>();

  SetsBased = SetsBased;
  WeightType = WeightType;

  RemoveCallBack = null;
  SaveCallBack = null;

  AboutLabel = $localize`:@@SmallAbout:about`;

  ButtonLabel = 'Add To Plan';
  ButtonAddedLabel = 'Added!';
  videoHtml = ""

  @Input('ShowEditButtons') ShowEditButtons: boolean = false;
  Name = '';

  changed: boolean = false;

  protected readonly unsubscribe$ = new Subject<void>();

  settingDetails: SettingDetailRow[] = [];

  isPlayingVideo: boolean = false;

  @ViewChild('video')
  public video: ElementRef;

  @ViewChild('image')
  public image: ElementRef;

  @Input('fitnessBlock') fitnessBlock: FitnessBlock;

  public advanceOptionForm: FormArray;

  /** ServiingSizeSelection ctor */
  constructor(
    private exerciseProgressService: ExerciseProgressData,
    private chdetRef: ChangeDetectorRef,
    protected ref: NbDialogRef<ExerciseEditComponent>,
    private fb: FormBuilder,
  ) {  
  }

  /**
   * Initializes the component.
   * Prepares the selection.
   */
  ngOnInit() {

    if (!this.FitnessItem && this.InputItem) {
      this.FitnessItem = CopyFitnessItem(this.InputItem);

      if (
        this.FitnessItem.restBeforeNextExercise &&
        this.FitnessItem.restBeforeNextExercise > 0
      )
        this.includeRest = true;
    }


    if (this.FitnessItem) {
      if (!this.FitnessItem.setsBased)
        this.FitnessItem.setsBased = SetsBased.RepsBased;
      if (!this.FitnessItem.sets) this.FitnessItem.sets = 3;
      if (!this.FitnessItem.defaultRepsOrTime)
        this.FitnessItem.defaultRepsOrTime = 8;
      if (!this.FitnessItem.defaultTempo) this.FitnessItem.defaultTempo = '';
      if (!this.FitnessItem.defaultRest && this.FitnessItem.defaultRest != 0)
        this.FitnessItem.defaultRest = 60;
      if (this.FitnessItem.weightType == undefined)
        this.FitnessItem.weightType = WeightType.AbsoluteValue;
      if (!this.FitnessItem.defaultWeight) this.FitnessItem.defaultWeight = convertKgToPounds(this.FitnessItem.defaultWeight, this.IsPreferredUnitImperial);
      if (!this.FitnessItem.oneRepMax) this.FitnessItem.oneRepMax = 0;
      if (!this.FitnessItem.instructions) this.FitnessItem.instructions = '';

      if (!this.FitnessItem.setSettings) {
        this.settingDetails = [];
        this.FitnessItem.setSettings = JSON.stringify(this.settingDetails);
      } else {
        this.settingDetails = JSON.parse(this.FitnessItem.setSettings);
      }

      if (this.IsTimeBasedType) {
        this.FitnessItem.defaultRepsOrTime = Math.round((this.FitnessItem.defaultRepsOrTime / 60) * 100) / 100;
      }

      this.exerciseProgressService
        .getOneMaxRep(this.PatientID, this.FitnessItem.exerciceId)
        .subscribe((data) => {
          if (data)
            this.FitnessItem.oneRepMax = data.oneMaxRep;
        });
    }
    this.buildForm();
  }

  private buildForm(): void {
    this.advanceOptionForm = this.fb.array(this.settingDetails.map(res => {
      return this.fb.group({
        Set: [res.Set],
        RepsOrTime: [res.RepsOrTime],
        Tempo: [res.Tempo],
        Rest: [res.Rest],
        Weight: [convertKgToPounds(parseFloat(res.Weight), this.IsPreferredUnitImperial)],
        UsedWeight: [res.UsedWeight],
        CalculatedWeight: [res.CalculatedWeight],
        displayWeight: [res.displayWeight]
      }) 
    }));
  }

  
  public getVideoUrl(source:string):string {
    return source + "#t=0.001"
  }


  ngAfterViewInit() {
    // this.image.nativeElement.focus();
  }

  includeRest: boolean = false;
  get IncludeRest(): boolean {
    return this.includeRest;
  }

  set IncludeRest(include: boolean) {
    this.includeRest = include;
    if (this.includeRest) {
      this.FitnessItem.restBeforeNextExercise = 30;
    } else {
      this.FitnessItem.restBeforeNextExercise = 0;
    }
  }

  /**
   * Function to apply selection of the exercise item.
   * Calcuates the metrics and updates the exercise item information.
   * @param item Exercise item
   */
  private applyItem(): void {


    if (this.IsTimeBasedType) {
      this.FitnessItem.defaultRepsOrTime = this.FitnessItem.defaultRepsOrTime * 60;
    }


    if (this.IsMaxRepType) {
      this.FitnessItem.defaultRepsOrTime = 0;

      this.settingDetails.forEach(y => y.RepsOrTime = '0');
    }


    this.saveSettings();
    // copy back to the original from edit item
    this.InputItem.sets = this.FitnessItem.sets;
    this.InputItem.setsBased = this.FitnessItem.setsBased;
    this.InputItem.defaultRepsOrTime = this.FitnessItem.defaultRepsOrTime;
    this.InputItem.defaultTempo = this.FitnessItem.defaultTempo;
    this.InputItem.defaultRest = this.FitnessItem.defaultRest;
    this.InputItem.weightType = this.FitnessItem.weightType;
    this.InputItem.defaultWeight = this.FitnessItem.defaultWeight;
    this.InputItem.oneRepMax = this.FitnessItem.oneRepMax;
    this.InputItem.restBeforeNextExercise =
      this.FitnessItem.restBeforeNextExercise;


    this.InputItem.setSettings = this.FitnessItem.setSettings;


    this.InputItem.useFemaleVersion = this.FitnessItem.useFemaleVersion;
    this.InputItem.showAdvancedMode = this.FitnessItem.showAdvancedMode;
    this.InputItem.instructions = this.FitnessItem.instructions;
    this.InputItem.customName = this.FitnessItem.customName;






    this.saveOneMaxRep();

    if (this.SaveCallBack) {
      this.SaveCallBack();
      this.ref.close();
    }

    this.chdetRef.detectChanges();
  }


  get IsSuperSet() {
    return FitnessItemHelper.IsSuperSet(this.FitnessItem);
  }

  get GetSupersetMaster(): FitnessItem {
    return FitnessItemHelper.GetSupersetMaster(this.FitnessItem, this.fitnessBlock);
  }

  get IsSupersetMaster() {
    return FitnessItemHelper.IsSupersetMaster(this.FitnessItem, this.fitnessBlock);
  }

  get IsSuperSetSlave() {
    return FitnessItemHelper.IsSuperSetSlave(this.FitnessItem, this.fitnessBlock);
  }

  get IsValidSuperset() {
    return FitnessItemHelper.GetSupersetMaster(this.FitnessItem, this.fitnessBlock) != null;
  }

  get IsCircuitMode(): boolean {
    if (this.fitnessBlock && (this.fitnessBlock.blockType.toString() === 'Circuit' || this.fitnessBlock.blockType.toString() === '1')) {
      return true;
    }

    return false;
  }

  toggleSettings() {
    this.FitnessItem.showAdvancedMode = !this.FitnessItem.showAdvancedMode;
    this.onChanged();
  }

  onAdvancedRepChange() {


    if (this.FitnessItem.setsBased == SetsBased.TimeBased) {

    }
  }

  resetSettings() {
    this.settingDetails = [];
    this.refreshSettings();
  }

  onChanged() {
    this.changed = true;

    if (!this.FitnessItem.defaultRepsOrTime) {
      this.FitnessItem.defaultRepsOrTime = 8;
     }

    if (this.FitnessItem.showAdvancedMode) {
      this.refreshSettings();
    } else {
      this.resetSettings();
    }
  }

  Save() {
    this.applyItem();

    this.ref.close();
  }

  Close() {
    this.ref.close();
  }

  Remove() {
    if (this.RemoveCallBack) {
      this.ref.close();
      this.RemoveCallBack();
    }
  }

  refreshSettings(expand: boolean = true) {
    // this.settingDetails = [];

    const prevSets = this.settingDetails.length;

    if (prevSets >= this.FitnessItem.sets) {
      this.settingDetails.splice(this.FitnessItem.sets);
    } else {
      for (let i = prevSets + 1; i <= this.FitnessItem.sets; i++) {
        const row = new SettingDetailRow();
        row.Set = i.toString();
        row.Tempo = this.FitnessItem.defaultTempo;

        if (this.FitnessItem.defaultRepsOrTime)
          row.RepsOrTime = this.FitnessItem.defaultRepsOrTime.toString();
        else row.RepsOrTime = '';


        // force 0 for MaxRepBased
        if (this.FitnessItem.setsBased == SetsBased.MaxRepBased) {
          row.RepsOrTime = '0';
        }

        if (this.FitnessItem.defaultWeight) {
          console.log('this.FitnessItem.defaultWeight', this.FitnessItem.defaultWeight)
          let defaultWeight = this.FitnessItem.defaultWeight;
          row.Weight = defaultWeight.toString();
        } else row.Weight = '';

        if (this.FitnessItem.defaultRest)
          row.Rest = this.FitnessItem.defaultRest.toString();
        else row.Rest = '';

        this.settingDetails.push(row);
      }
    }

    this.FitnessItem.setSettings = JSON.stringify(this.settingDetails);
    this.buildForm();
    this.changed = false;
  }

  get RepLabel() {


    let supersetMaster = this.GetSupersetMaster;

    if (supersetMaster != null) {
      if (supersetMaster.setsBased == SetsBased.RepsBased) return 'Reps';
      if (supersetMaster.setsBased == SetsBased.Superset) return 'Reps';
      if (supersetMaster.setsBased == SetsBased.MaxRepBased) return 'Reps';
      else return 'Time (min)';
    }

    if (this.FitnessItem.setsBased == SetsBased.RepsBased) return 'Reps';
    if (this.FitnessItem.setsBased == SetsBased.Superset) return 'Reps';
    if (this.FitnessItem.setsBased == SetsBased.MaxRepBased) return 'Reps';
    else return 'Time (min)';
  }

  get IsMaxRepType():boolean {
    let supersetMaster = this.GetSupersetMaster;
    if (supersetMaster != null) {
      if (supersetMaster.setsBased == SetsBased.MaxRepBased) return true;
    }
    if (this.FitnessItem.setsBased == SetsBased.MaxRepBased) return true;
  }

  
  get IsTimeBasedType():boolean {
    let supersetMaster = this.GetSupersetMaster;
    if (supersetMaster != null) {
      if (supersetMaster.setsBased == SetsBased.TimeBased) return true;
    }
    if (this.FitnessItem.setsBased == SetsBased.TimeBased) return true;
    if (this.FitnessItem.setsBased.toString() == SetsBased.TimeBased.toString()) return true;
  }

  onAdd() {
    this.changed = true;

    this.saveSettings();

    this.saveOneMaxRep();

    if (this.IsMaxRepType) {
      this.FitnessItem.defaultRepsOrTime = 0;

      this.settingDetails.forEach(y => y.RepsOrTime = '0');
    }

    const cloneExercise: any = cloneDeep(this.FitnessItem);

    if (this.IsTimeBasedType) {
      cloneExercise.defaultRepsOrTime = cloneExercise.defaultRepsOrTime * 60;
    }
    this.added.emit(cloneExercise);
  }

  saveSettings() {
    if (!this.FitnessItem.setSettings || !this.FitnessItem.showAdvancedMode) this.refreshSettings(false);
    let out = this.advanceOptionForm.value;
    if(this.IsPreferredUnitImperial) {
      out = this.advanceOptionForm.value.map(x => {
        return {
          ...x,
          Weight: convertPoundsToKg(x.Weight, this.IsPreferredUnitImperial)
        }
      })
    }

    this.FitnessItem.setSettings = JSON.stringify(out);
  }

  saveOneMaxRep() {
    const exProgress: any = {
      patientID: this.PatientID,
      exerciceId: this.FitnessItem.exerciceId,
      oneMaxRep: this.FitnessItem.oneRepMax,
    };

    this.exerciseProgressService
      .changeOneMaxRep(exProgress)
      .subscribe(() => { });
  }

  onVideoChange() {
    this.video.nativeElement.load();
    this.isPlayingVideo = false;
  }

  onPlayVideo() {
    this.isPlayingVideo = true;
    this.video.nativeElement.play();
  }

  onVideoEnded() {
    this.isPlayingVideo = false;
  }
}
